(function () {
  var scrollbarUpdaters = [];

  function initReviewScrollbars(root) {
    var scope = root || document;
    var wraps = scope.querySelectorAll(".reviews__text-wrap:not([data-scrollbar-init])");

    wraps.forEach(function (wrap) {
      var text = wrap.querySelector(".reviews__text");
      var track = wrap.querySelector(".reviews__scrollbar");
      var thumb = wrap.querySelector(".reviews__scrollbar-thumb");

      if (!text || !track || !thumb) {
        return;
      }

      wrap.setAttribute("data-scrollbar-init", "true");

      function updateScrollbar() {
        var scrollHeight = text.scrollHeight;
        var clientHeight = text.clientHeight;
        var scrollTop = text.scrollTop;

        if (scrollHeight <= clientHeight + 1) {
          track.classList.remove("reviews__scrollbar--visible");
          return;
        }

        track.classList.add("reviews__scrollbar--visible");

        var trackHeight = track.clientHeight;
        var thumbHeight = Math.max(20, (clientHeight / scrollHeight) * trackHeight);
        var maxOffset = trackHeight - thumbHeight;
        var offset = maxOffset * (scrollTop / (scrollHeight - clientHeight));

        thumb.style.height = thumbHeight + "px";
        thumb.style.transform = "translateY(" + offset + "px)";
      }

      text.addEventListener("scroll", updateScrollbar, { passive: true });
      scrollbarUpdaters.push(updateScrollbar);
      updateScrollbar();
    });
  }

  function updateAllScrollbars() {
    scrollbarUpdaters.forEach(function (update) {
      update();
    });
  }

  function initReviewsSlider(sliderEl) {
    if (!sliderEl || typeof Swiper === "undefined") {
      return;
    }

    var sectionEl = sliderEl.closest(".reviews");

    new Swiper(sliderEl, {
      slidesPerView: "auto",
      spaceBetween: 14,
      speed: 500,
      watchOverflow: true,
      pagination: {
        el: sectionEl ? sectionEl.querySelector(".reviews__pagination") : ".reviews__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: sectionEl ? sectionEl.querySelector(".reviews__arrow--next") : ".reviews__arrow--next",
        prevEl: sectionEl ? sectionEl.querySelector(".reviews__arrow--prev") : ".reviews__arrow--prev",
      },
      breakpoints: {
        768: {
          spaceBetween: 14,
        },
      },
      on: {
        init: function () {
          initReviewScrollbars(sliderEl);
        },
        resize: updateAllScrollbars,
      },
    });
  }

  document.querySelectorAll("[data-reviews-slider]").forEach(function (sliderEl) {
    initReviewsSlider(sliderEl);
  });

  document.querySelectorAll(".reviews").forEach(function (sectionEl) {
    initReviewScrollbars(sectionEl);
  });

  window.addEventListener("resize", updateAllScrollbars);
})();
